import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loading.gif'


const _withScopeId = n => (_pushScopeId("data-v-5f02114b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "loader__img",
    src: _imports_0,
    alt: "loading..."
  })
], -1))
const _hoisted_2 = {
  key: 0,
  class: "loader__title"
}
const _hoisted_3 = {
  key: 1,
  class: "loader__description"
}

import { useLoadingStore } from '@/store/loadingStore'
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoaderComponent',
  setup(__props) {

const store = useLoadingStore()
const { loading, fullscreen, background, title, description } = storeToRefs(store)

const bgColorClass = computed(() => {
  switch (background.value) {
    case 'dimmed':
      return 'bg-black-40'
    case 'transparent':
      return 'bg-transparent'
    case 'white':
      return 'bg-white'
    default:
      return 'bg-black-40'
  }
})

watch(loading, (value) => {
  // console.log(loading.value)
  if (value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'unset'
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade-op" }, {
      default: _withCtx(() => [
        (_unref(loading) && _unref(fullscreen))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['loader-background', bgColorClass.value])
            }, null, 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade-op" }, {
      default: _withCtx(() => [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['loader-wrap', bgColorClass.value])
            }, [
              _hoisted_1,
              (_unref(title))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(title)), 1))
                : _createCommentVNode("", true),
              (_unref(description))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(description)), 1))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})